import { render, staticRenderFns } from "./selectFromDictionary.vue?vue&type=template&id=b33d64bc"
import script from "./selectFromDictionary.vue?vue&type=script&lang=js"
export * from "./selectFromDictionary.vue?vue&type=script&lang=js"
import style0 from "./selectFromDictionary.vue?vue&type=style&index=0&id=b33d64bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports